import { gql } from 'apollo-angular';

export const LIST_SUPPLIER_APPLICATIONS = gql`
  query ListSupplierPreQualificationsByCurrentUser($pageableParam: PageableParamInput!) {
    listSupplierPreQualificationsByCurrentUser(pageableParam: $pageableParam) {
      number
      size
      totalElements
      content {
        uuid
        status
        createdAt
        preQualificationExpiryDate
        evaluated
        evaluatedAt
        evaluatedByName
        resubmissionEndDate
        status
        company {
          uuid
          name
          brelaRegistrationNumber
        }
        supplier {
          uuid
          name
        }
        bills {
          uuid
          billNumber
          billStatus
          controlNumber
          currency
          totalAmountAfterTax
          billDate
        }
      }
    }
  }
`;

export const VIEW_SUPPLIER_APPLICATION = gql`
  query GetSupplierPreQualificationByUuid($uuid: String!) {
    getSupplierPreQualificationByUuid(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        id
        preQualificationExpiryDate
        resubmissionEndDate
        status
        submittedAt
        createdAt
        canResubmit
        identifiedShortfalls
        finalEvaluationRemark
        uuid
        checklistItems {
          active
          attachableDiscriminator
          attachmentUploaded
          bucketName
          id
          otherAttachmentName
          registrationType
          supplierComments
          checklistEvaluation
          uuid
          attachments {
            active
            id
            minioObjectName
            otherAttachmentName
            uuid
            attachable {
              attachableDiscriminator
              bucketName
              id
              otherAttachmentName
              registrationType
              uuid
            }
            attachmentType {
              active
              fileSize
              fileType
              id
              kind
              name
              uuid
            }
          }
          checklistCriteria {
            active
            attachmentRequired
            criteriaNumber
            description
            id
            isMandatory
            sequenceNumber
            uuid
            attachmentType {
              active
              fileSize
              fileType
              id
              kind
              name
              uuid
            }
          }
        }
        bills {
          billDate
          billNumber
          billStatus
          clientName
          clientPhoneNumber
          controlNumber
          currency
          description
          id
          totalAmountAfterTax
          uuid
          itemList {
            collectionCenter
            collectionCenterId
            description
            gfsCode
            id
            isExempted
            quantity
            taxAmount
            totalAmount
            unitPrice
            billItemDetails {
              details
              id
              quantification
              taxAmount
              totalAmount
              unitPrice
            }
          }
        }
        supplier {
          active
          id
          name
          uuid
        }
      }
    }
  }
`;


export const REVOKE_SUPPLIERPREQUALIFICATION = gql`
mutation RevokeSupplierPrequalificationToDraft($preQualificationUuid: String!) {
    revokeSupplierPrequalificationToDraft(preQualificationUuid: $preQualificationUuid) {
        code
        data {
            active
            id
            uuid
            workflowStatus
            status
        }
        extras
        fieldsErrors
        message
        status
    }
}`;